<div class="modal-body">
    <div class="fc_modal_body">
    <button type="button" class="btn-close" (click)="activeModal.close(false);"></button>
    <!-- Executor decline -->
                <h3 class="h3 mt-4">Are you sure you want to decline the invitation?</h3>
                <p>{{familyInviationService.executorInvitationDetails?.firstName}}
                    {{familyInviationService.executorInvitationDetails?.lastName}} will receive an email regarding your preference.</p>
                <div class="form-group d-flex justify-content-end mbl-column">
                    <button type="button" name="next" class="primary_btn"
                        disableDuringAjax (click)="activeModal.close(true)">Decline</button>
            </div>
        </div>
    </div>
    <!-- End Executor decline -->
